import { EntityData } from "@/components/TriggerSetup/logic/types/entity-data.type";
import { baseCondition } from "@/components/TriggerSetup/logic/structures/base-condition.structure";
import { TriggerCondition } from "@/components/TriggerSetup/logic/types/types";
import WorkMonthDaysSetupView from "./WorkMonthDaysSetupView.vue";
import { snakeCase } from "lodash";
import { getTagsByFieldKey } from '@/mixins/TariffsTagsHelper'

const condition: () => EntityData = () => {
  return {
    'setupView': WorkMonthDaysSetupView,
    'structure': {
      'type': 'WorkMonthDays',
      ...baseCondition,
    } as TriggerCondition,
    'titleKey': `trigger_condition_${ snakeCase('WorkMonthDays') }`,
    'limited': getTagsByFieldKey('WorkMonthDaysCondition'),
  }
}

export default condition
